var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare07 = function SvgShare07(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "m6.393 9.007 4.554 2.653m-.007-7.32L6.393 6.993m8.274-3.66a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6.667 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m8 4.667a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
export default SvgShare07;